import { useNavigate } from "@tanstack/react-router";
import React, { useEffect, useState } from "react";

import useSiteConfigAuth from "@/api/sanity/queries/getSiteConfigWithCode";
import Spacer from "@/components/Spacer";
import useGetColours from "@/helpers/getColours";

import faqData from "./faqData.json";

function FaqPage() {
  const { data: siteConfig } = useSiteConfigAuth();
  const { darkColour } = useGetColours();
  const [filteredFaqs, setFilteredFaqs] = useState([]);
  const navigate = useNavigate();
  const isRoughTrade = siteConfig?.display_name?.includes("Rough Trade Publishing");
  const isCookingVinyl = siteConfig?.display_name?.includes("Cooking Vinyl Publishing");

  useEffect(() => {
    if (!isRoughTrade && !isCookingVinyl) {
      navigate({ to: "/" });
    }
  }, [isRoughTrade, isCookingVinyl, navigate]);

  useEffect(() => {
    if (siteConfig?.display_name) {
      const clientFaq = faqData.find(
        client => client.clientName === siteConfig.display_name,
      );
      setFilteredFaqs(clientFaq ? clientFaq.faq : []);
    }
  }, [siteConfig]);

  return (
    <div className="flex flex-wrap">
      <div className="w-full lg:min-h-screen-minus-header">
        <div className="mx-4 my-12 lg:mx-12 xl:mx-20 2xl:mx-40">
          <div
            style={{ backgroundColor: darkColour }}
            className="flex flex-col items-center w-full px-8 text-white rounded-lg h-60 sm:h-52 sm:flex-row justify-evenly sm:justify-between"
          >
            <h1 className="order-2 mt-1 text-4xl font-semibold md:text-7xl sm:order-1">
              Royalties FAQ's
            </h1>
            {siteConfig?.logo && (
              <img className="order-1 h-1/4 sm:h-1/2 sm:order-2" src={siteConfig.logo} alt="logo" />
            )}
          </div>
          <Spacer />
          <div className="flex flex-col gap-12 px-8 pt-12 pb-20 bg-white rounded-lg shadow-lg ">
            {filteredFaqs.map((item, index) => (
              <React.Fragment key={item.id}>
                <div>
                  <h1 className="text-2xl font-semibold font-sentric md:text-3xl">
                    {item.question}
                  </h1>
                  <p className="mt-2 text-lg font-sentric-alt">{item.answer}</p>
                </div>
                {index < filteredFaqs.length - 1 && (
                  <hr className="mx-12 border-t-2 border-black/15" />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
export default FaqPage;
